<template>
    <div
        v-once
        class="text-s-left">
        <h2 class="sectionRooftitle text-left">
            {{ trans('RELEASE_CALENDAR') }}
        </h2>
        <div class="flex">
            <h3 class="h2 margin-bottom-15 text-left width50 width-s-100">
                {{ trans('INFOGRAPHIC_RELEASE_CALENDAR_PLANNED') }}
            </h3>
            <template v-if="!isMobile">
                <div class="width50 flex flex--center flex--justifyContent-end">
                    <p>{{ trans('XMO_HIGHLIGHTS_SHOW_ALL') }}</p>
                    <div
                        class="highlightsToggleSwitch__wrapper highlightsToggleSwitch__wrapper--releaseLists display-inline-block"
                        aria-hidden="true">
                        <input
                            :id="`show${ currentOutlook }`"
                            v-model="filterReleases"
                            type="checkbox"
                            class="highlightsToggleSwitch__input"
                            data-gtm="highlightsToggleSwitch__input">
                        <label :for="`show${ currentOutlook }`">
                            <span class="visually-hidden">
                                {{ trans('RELEASE_CALENDAR_TOGGLE_CHECKBOX') }}
                            </span>
                        </label>
                    </div>
                    <span>
                        {{ trans('XMO_HIGHLIGHTS_SHOW_MARKET').replace('{currentOutlook}', getMarketPrefix) }}
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
    import Translator from 'tools/trans';
    import { mapState } from 'vuex';

    const LOCALE_DE = 'de';
    const ECOMMERCE = 'eCommerce';

    export default {
        props: {
            marketName: {
                type: String,
                required: true,
            },
            isMobile: {
                type: Boolean,
                required: true,
            },
            locale: {
                type: String,
                default: '',
            },
        },
        data() {
            return {
                filterReleases: true,
            };
        },
        computed: {
            ...mapState([
                'currentOutlook',
            ]),
            getMarketPrefix() {
                if (this.locale === LOCALE_DE || this.marketName === ECOMMERCE) {
                    return this.marketName;
                }

                return this.marketName.toLocaleLowerCase();
            },
        },
        watch: {
            filterReleases(value) {
                this.$emit('filter-releases', value);
            },
        },
        methods: {
            trans: Translator.trans,
        },
        mounted() {
            this.$emit('filter-releases', this.filterReleases);
        },
    };
</script>
